export default {
    login: {
        title: 'Welcome to login',
        mobile: 'Please enter your mobile',
        password: 'Please enter your password',
        oldpassword: 'Please enter your old password',
        confirmPwd: 'Please enter the confirmation password',
        verificationCode: 'Please enter the verification code',
        loginIn: 'Login',
        register: 'Register',
        reset: 'Reset',
        resetPwd: 'Reset Password',
        editPwd: 'Edit Password',
        newPwd: 'Please enter a new password'
    },
    Notification: {
        suc_title: 'Success',
        suc_login_msg: 'Login Success',
        suc_register_msg: 'Register Success',
        suc_send_msg: 'Send Success',
        suc_edit_msg: 'Edit Success',
        suc_reset_msg: 'Reset Success',
        codeAgain: 'Recapture Captcha',
        suc_submit: 'Submit Success',
        login_tip: 'Please Log In First',
        tip: 'Tip',
        sure: 'Sure',
        next: 'Next',
        requiredFields: 'Please complete the required fields',
        nodata: 'No Data',
        read: 'Read',
        unread: 'Unread',
        cancel: 'Cancel',
        suc_confirm_msg: 'Successful Confirmation'
    },
    tougao: {
        submit: 'Submit',
        correct_mobile: 'Please enter the correct mobile',
        correct_email: 'Please enter the correct email',
        corrent_card: 'Please enter the correct Card',
        basic_info: 'Member Info',
        zuopin_info: 'Work Info',
        cancel: 'Cancel',
        sure: 'Sure',
        receipt: 'Submission Receipt',
        print: 'Print',
        submit_tip: 'Confirm that no modification can be made after submission. Whether to continue',
        suc_confirm_msg: 'Successful Confirmation'
    },
    my: {
        name: 'Name',
        category: 'Category',
        ticket: 'Ticket',
        status: 'Status',
        operate: 'Operate',
        edit: 'Edit',
        confirm: 'Confirm',
        view: 'View',
        receipt: 'Receipt',
        logout: 'Logout',
        activity: 'Registration List',
        personal: 'Personal',
        message: 'Message List',
        personalInfo: 'Personal Info',
        myActivity: 'My Activities',
        myMessage: 'My Message',
        personalCenter: 'Personal',
        filter: 'Fitler',
        keyPlhder: 'Please enter the search keyword',
        statusPlhder: 'Please select the active state',
        num: 'Number',
        activityName: 'Name of activity',
        desc: 'Description',
        createTime: 'Create Time',
        enable: 'Enable',
        disabled: 'Disabled',
        apply: 'Apply',
        zuopinCategory: 'Category of works',
        zuopinName: 'Name of works',
        submitTime: 'Submit Time',
        submit: 'Submit',
        zuopinList: 'List of works',
        back: 'Back',
        add: 'Add',
        nodata: 'No Data',
        msgDetail: 'Message Detail',
        personTip: 'Please take care of personal information',
        editPwdTip: 'Please keep the password carefully',
        avatar: 'Avatar',
        uploadAvatar: 'upload photo as avatar',
        realName: 'RealName',
        realNamePlac: 'Please enter your real name',
        mobile: 'Mobile',
        sex: 'Sex',
        sexPlac: 'Please select gender',
        editPersonal: 'Edit Personal',
        oldPwd: 'Old Password',
        newPwd: 'New Password',
        confirmPwd: 'Confirm Password',
        oldPwdTip: 'Please enter the old password',
        newPwdTip: 'Please enter a new password',
        confirmPwdTip: 'Please enter the confirmation password'
    }
}
